import React from 'react'
import Box from '@amzn/meridian/box'
import Icon from '@amzn/meridian/icon'
import Text from '@amzn/meridian/text'
import chevronSelectTokens from '@amzn/meridian-tokens/base/icon/chevron-select'
import { IStoreFilterSelectProps } from '../types'
import './StoreFilterSelect.scss'

/**
 * StoreFilterSelect Component
 *
 * Tappable display component that shows the current store filter state.
 * Displays "All stores" when no filter is active, or "X of N stores" when a filter is active.
 * Tapping opens the StoreFilterSheet bottom sheet.
 */
export const StoreFilterSelect: React.FC<IStoreFilterSelectProps> = ({ displayText, onTap, isOpen }) => {
    return (
        <Box type="fill" spacingInset="300 400">
            <button
                className="store-filter-select"
                onClick={onTap}
                data-testid="store-filter-select"
                type="button"
                aria-haspopup="dialog"
                aria-expanded={isOpen}
            >
                <Text>{displayText}</Text>
                <Icon tokens={chevronSelectTokens} />
            </button>
        </Box>
    )
}
